

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 22"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M17.08 1.92c2.17 2.05 2.23 4.19.18 6.36l-8.21 8.69c-.42.45-1.2.87-1.81.97l-3.22.55c-.17.01-.32.03-.48.03-.61 0-1.18-.21-1.59-.6-.52-.49-.77-1.23-.68-2.03l.37-3.24c.07-.61.44-1.42.87-1.86l8.21-8.69c2.05-2.17 4.19-2.23 6.36-.18ZM9.518 5.537 3.6 11.81c-.2.21-.43.71-.47 1l-.37 3.24c-.04.33.04.6.22.77.18.17.45.23.78.18l3.22-.55c.29-.05.77-.31.97-.52l5.921-6.267a6.86 6.86 0 0 1-4.353-4.126ZM13.93 1.91c-.77 0-1.44.48-2.12 1.2l-1.097 1.16a5.372 5.372 0 0 0 4.342 4.14l1.105-1.17C17.4 5.92 17.85 4.7 16.04 3c-.8-.77-1.49-1.09-2.11-1.09ZM1 21.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75H1Z"}, []), "\n"]);
};

        